var _ellipse, _path, _path2, _path3, _path4, _path5, _ellipse2, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCellsAndHouse = function SvgCellsAndHouse(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 106 99"
  }, props), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52.982,
    cy: 92.657,
    fill: "#1B1C1C",
    opacity: 0.1,
    rx: 50.627,
    ry: 5.061
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    stroke: "#606363",
    strokeMiterlimit: 10,
    strokeWidth: 0.813,
    d: "M54.806 57.324H4.746v33.362h50.06z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F8F8F8",
    stroke: "#606363",
    strokeMiterlimit: 10,
    strokeWidth: 0.813,
    d: "m54.765 56.694 22.953-28.395 22.128 28.395v34.065h-45.08z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#606363",
    d: "m1.392 57.325 24.371-30.147h53.414l-24.37 30.147z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#606363",
    d: "m79.177 27.178 24.456 31.242h-3.747v-1.052L77.722 28.676z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#606363",
    strokeMiterlimit: 10,
    strokeWidth: 0.813,
    d: "M84.437 69.758H71.245v20.98h13.192z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 30,
    cy: 49.063,
    fill: "#000",
    fillOpacity: 0.1,
    rx: 30,
    ry: 4.354
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#737373",
    d: "M63.397 13.45 49.582 45.443a3 3 0 0 1-2.754 1.81H3.153a1 1 0 0 1-.91-1.413L16.8 13.812a3 3 0 0 1 2.73-1.759H62.48a1 1 0 0 1 .918 1.397Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    d: "m16.343 46.251-.202.458.914.404.202-.458zm15.2-34.4-15.2 34.4.914.404 15.2-34.4zM32.341 46.735l-.198.46.918.396.198-.46zm15.2-35.2-15.2 35.2.918.397 15.2-35.2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#737373",
    d: "M12.8 24.353h-.5v1h.5zm0 1h45.6v-1H12.8zM8 35.553h-.5v1H8zm0 1h45.6v-1H8z"
  })));
};
export default SvgCellsAndHouse;